import { GraphQlClient, Lodash } from '@intelipost-js/secure-providers';
import { ScToast } from '@intelipost-js/secure-components';

export default {
  createSchema({ commit }, data) {
    const {
      name,
      search_value,
      origin_zipcode,
      destination_zipcodes,
      capacity_template,
      source,
      date_range,
      enabled,
    } = data;
    const { type } = source;

    return GraphQlClient.mutation(
      `
        mutation(
          $name: String,
          $source: CapacitySchemaSourceType,
          $origin_zipcode: String,
          $destination_zipcodes: [CapacitySchemaZipCodeRangeType],
          $date_range: CapacitySchemaDateRangeType,
          $enabled: Boolean,
          $capacity_template: CapacitySchemaTemplateType,

        ) {

          createCapacitySchema(
            name: $name,
            source: $source,
            origin_zipcode: $origin_zipcode,
            destination_zipcodes: $destination_zipcodes,
            date_range: $date_range,
            enabled: $enabled,
            capacity_template: $capacity_template,

          ) {
            id
          }
        }`,
      {
        name,
        source: {
          type,
          id: search_value,
        },
        capacity_template,
        origin_zipcode,
        date_range,
        destination_zipcodes,
        enabled,
      },
    )
      .then(() => {
        commit('toggleLoading', false);

        ScToast.success('Esquema salvo');

        return Promise.resolve({});
      })
      .catch(() => Promise.reject({ error: 'O esquema não foi salvo' }));
  },
  setPeriodicity({ commit }) {
    return GraphQlClient.query(
      `
        query ($periodicity: String) {
          capacityTemplateWindowPeriods(
            periodicity: $periodicity
          ) {
            periods {
              period
              label
              adjustment_percentage
              enabled
              created
            }
          }
        }`,
      { periodicity: 'DAILY' },
    ).then((resp) => {
      const { data } = resp || {};
      const { capacityTemplateWindowPeriods = {} } = data || {};

      commit('setPeriodicity', capacityTemplateWindowPeriods);

      return Promise.resolve({});
    });
  },
  getSchemas({ commit }, payload) {
    const { limit, page } = payload || {};

    commit('toggleLoading', true);
    return GraphQlClient.query(
      `
        query($pagination: CapacitySchemaPagination){
          capacitySchemas(pagination:$pagination){
            items {
              id
              name
              source {
                name
                type
              }
              enabled
              created
              origin_zipcode
              modification {
                date_time
                author
              }
              date_range {
                start
                end
              }
            }
            total
          }
        }`,
      { pagination: { limit, page } },
    )
      .then((resp) => {
        const { data } = resp || {};
        const { capacitySchemas = {} } = data || {};

        commit('toggleLoading', false);
        commit('setSchemaList', capacitySchemas);

        return Promise.resolve({});
      })
      .catch(() => Promise.reject({}));
  },

  getSchemaDetails({ commit }, schemaId) {
    commit('toggleLoading', true);
    return GraphQlClient.query(
      `
      query($id: Int){
        capacitySchemaById(id: $id){
        name
        id
        created
        origin_zipcode
        enabled
        date_range {
          start
          end
          }
        source {
          type
          name
        }
        destination_zipcodes {
          start
          end
        }
        capacity_template {
          lead_time
          windows {
            start
            end
            periods {
              period
              adjustment_percentage
              enabled
              label
              created
            }
          }
        }
      }
    }
    `,
      { id: schemaId },
    )
      .then((resp) => {
        const { data } = resp || {};
        const { capacitySchemaById = {} } = data || {};

        commit('toggleLoading', false);
        commit('setSchemaDetails', capacitySchemaById);
      })
      .catch(() => Promise.reject({}));
  },
  enabledSchema({ commit, state }, payload) {
    commit('toggleLoading', true);

    const { id, enabled } = payload;
    const newSchemaList = Lodash.cloneDeep(state.schemaList);
    const currentSchemaIndex = newSchemaList.items
      .findIndex(currentSchemaItem => currentSchemaItem.id === id);
    newSchemaList.items[currentSchemaIndex].enabled = enabled;
    commit('setSchemaList', newSchemaList);

    return GraphQlClient.mutation(
      `
        mutation (
          $id: Int
          $enabled: Boolean,
        ) {
        updateCapacitySchemaEnabled (
          id: $id,
          enabled: $enabled,
        ) {
            ok
          }
        }`,
      payload,
    )
      .then(() => {
        commit('toggleLoading', false);
        ScToast.success('Requisição realizada com sucesso');
      })
      .catch((err) => {
        const newSchemaListError = Lodash.cloneDeep(state.schemaList);
        newSchemaListError.items[currentSchemaIndex].enabled = !enabled;
        commit('setSchemaList', newSchemaListError);
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-capacity-management/features/schema/store/actions.js